import React from "react";
import { Crown } from "lucide-react";
import { ABOUT_BIO, ARTIST } from "../mock";

const About = () => {
  return (
    <section
      id="about"
      className="relative py-28 md:py-36 overflow-hidden bg-[#0a0410]"
    >
      {/* Cosmic purple/gold texture */}
      <div className="absolute inset-0">
        <div className="absolute top-0 left-1/4 w-[600px] h-[600px] rounded-full bg-[#6d28d9]/25 blur-[140px]" />
        <div className="absolute bottom-0 right-1/4 w-[500px] h-[500px] rounded-full bg-[#d4af37]/12 blur-[140px]" />
        <div className="absolute inset-0 opacity-[0.15] bg-[radial-gradient(circle_at_20%_30%,rgba(255,255,255,0.35)_0.5px,transparent_1px),radial-gradient(circle_at_70%_60%,rgba(255,255,255,0.25)_0.5px,transparent_1px)] [background-size:80px_80px,120px_120px]" />
      </div>

      <div className="relative max-w-[900px] mx-auto px-6 text-center">
        <div className="flex justify-center mb-6">
          <span className="flex items-center justify-center w-14 h-14 rounded-full border border-[#d4af37]/50 bg-black/30 backdrop-blur-sm">
            <Crown className="text-[#e8c65a]" size={26} />
          </span>
        </div>
        <h2 className="heading-display gold-text text-4xl md:text-6xl mb-10">THE KING</h2>
        <p className="text-neutral-200 text-lg md:text-xl leading-relaxed md:leading-loose">
          {ABOUT_BIO}
        </p>
        <p className="mt-10 text-[#c9a24a] tracking-[0.3em] uppercase text-xs">
          {ARTIST.taglineShort}
        </p>
      </div>
    </section>
  );
};

export default About;
